import { useToggle } from '@kiper/hooks';
import { Flex, Modal } from '@kiper/ui';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import helpUseAppGif from '../../../../assets/animations/helpUseAppGif.gif';
import inviteGuestInvalid from '../../../../assets/images/invite-guest-invalid.svg';
import logoPorterLogoIcon from '../../../../assets/images/summit-porter-logo-icon.svg';
import logoPorter from '../../../../assets/images/white-logo-porter.svg';
import { FacialInvitationPorterSummitModal } from '../../../../components/Modals';
import useRemoteConfig from '../../../../hooks/useRemoteConfig';
import { InviteGuestContext } from '../../../../store/InviteGuest';
import { RegisterFacial } from './components';
import * as S from './styles';

const PORTER_LANDING_PAGE_URL = 'https://lp.porter.com.br/porterportaria';

const CustomInvite = () => {
  const [t] = useTranslation('invite');
  const [openModal, toggleModal] = useToggle(false);

  const [toggleModalFaceCapture, setToggleModalFaceCapture] = useState(false);

  const {
    refetchInviteGuest,
    guestHash,
    formattedValues,
    inviteInvalid,
    condominium,
    inviteExpired,
  } = useContext(InviteGuestContext);

  const isActiveRemoteExpireInvite = useRemoteConfig({
    path: 'inviteGuest.activeRemoteExpireInvite',
    condominium: Number(condominium?.personContextId),
  });

  const handleToggleModalRegisterFacial = () =>
    setToggleModalFaceCapture(prevState => !prevState);

  const isExpired = inviteExpired || isActiveRemoteExpireInvite;

  return (
    <>
      {toggleModalFaceCapture && (
        <FacialInvitationPorterSummitModal
          onToggle={handleToggleModalRegisterFacial}
          guestHash={guestHash}
          refetch={refetchInviteGuest}
        />
      )}
      {openModal && (
        <Modal
          open={openModal}
          toggle={toggleModal}
          size="sm"
          title={t('feedback.modal-title')}
        >
          <Flex alignItems="center" justifyContent="center">
            <img src={helpUseAppGif} alt="helpAppKiper" />
          </Flex>
        </Modal>
      )}

      <S.Wrapper
        style={{
          backgroundImage: `url(${formattedValues.customBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100vw',
          height: '100vh',
        }}
      >
        <S.Content>
          <S.InviteContainer>
            {inviteInvalid && (
              <Flex
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gridGap="24px"
              >
                <S.InviteInvalid background={inviteGuestInvalid} />
                <Flex
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  gridGap="8px"
                >
                  <S.Span warning>{t(`feedback.invalid`)}</S.Span>
                  <S.Span>{t(`feedback.invalid-context`)}</S.Span>
                </Flex>
              </Flex>
            )}

            {!inviteInvalid && (
              <>
                {isExpired && (
                  <>
                    <RegisterFacial.ExpiredHeader />
                    <RegisterFacial.Expired />
                  </>
                )}

                {!isExpired && !formattedValues.hasFaceId && (
                  <>
                    <RegisterFacial.DefaultHeader
                      customInviteName={formattedValues.customInviteName}
                    />
                    <RegisterFacial.Create
                      onRegisterFacial={handleToggleModalRegisterFacial}
                    />
                  </>
                )}

                {!isExpired && formattedValues.hasFaceId && (
                  <>
                    <RegisterFacial.DefaultHeader
                      customInviteName={formattedValues.customInviteName}
                    />
                    <RegisterFacial.Edit
                      onEditFacial={handleToggleModalRegisterFacial}
                    />
                  </>
                )}

                <S.AnchorsWrapper>
                  <S.PorterLandingPageAnchor
                    href={
                      formattedValues.customPorterUrl || PORTER_LANDING_PAGE_URL
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.WrapperIcon>
                      <img
                        src={logoPorterLogoIcon}
                        alt={t('custom-invite.learn-more.button')}
                      />
                    </S.WrapperIcon>
                    <S.AnchorDescription>
                      <S.AnchorTitleText>
                        {t('custom-invite.learn-more.title')}
                      </S.AnchorTitleText>
                      <S.AnchorDescriptionText>
                        {t('custom-invite.learn-more.description')}
                      </S.AnchorDescriptionText>
                    </S.AnchorDescription>
                  </S.PorterLandingPageAnchor>
                </S.AnchorsWrapper>

                {formattedValues.customBanner && (
                  <S.BrandAreaFooter>
                    <S.BrandWrapper
                      href={formattedValues.customBannerUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={formattedValues.customBanner} alt="Evento" />
                    </S.BrandWrapper>
                  </S.BrandAreaFooter>
                )}
              </>
            )}
          </S.InviteContainer>
          <S.InviteFooter>
            <S.Img
              src={logoPorter}
              alt={t('custom-invite.footer.sponsor-logo-alt')}
            />
          </S.InviteFooter>
        </S.Content>
      </S.Wrapper>
    </>
  );
};

export default CustomInvite;
